import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// import { config } from 'src/app/config';
// import { User } from 'src/app/models/user.model';
// import { Store } from 'store';
// import { CourseService } from 'src/app/services/course.service';
import { ScoreFaqModalComponent } from '../../score-faq-modal/score-faq-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from 'src/app/core/store/store';
import { CourseService } from 'src/app/shared/services/course.service';
import { User } from 'src/app/shared/models/user.model';
// declare var amplitude;
declare var ga;
declare var mixpanel;

@Component({
  selector: 'app-begin-exercise',
  templateUrl: './begin-exercise.component.html',
  styleUrls: ['./begin-exercise.component.css']
})
export class BeginExerciseComponent implements OnInit {
  @Input()
  exerciseDetails: {
    moduleName: string,
    title: string,
    duration: number,
    numberOfQuestions: number,
    totalPoints: number,
    courseTitle: string,
    type: string
  };
  @Input() exerciseData: any = null;
  @Input() exerciseId: any;
  @Input() course;
  isLoaded = false;
  user;
  @Output()
  exerciseStarted: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  enableCustomiseMessaging: boolean = false;

  exerciseDesc = {
    PRACTICE: "Practice improves Effort and builds Confidence.\nThese exercises are designed to reinforce the concepts you have learned.",
    CAPSTONE: "It’s time to assess your learning progress. \n Your grades from here go towards generating your Course Score. \n All the best!",
  }



  constructor(private store: Store, private courseService: CourseService, private modalService: NgbModal) { }

  ngOnInit() {
    this.store.select<User>('user').subscribe(user => {
      if (user) {
        this.user = user;
      }
    });
    console.log(this.course);
    console.log(this.exerciseData);
    this.enableCustomiseMessaging = this.course.enableCustomiseMessaging;
    console.log(this.enableCustomiseMessaging);
  }
  startExercise() {
    /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
    amplitude.getInstance().setUserId(this.user.email);
    amplitude.getInstance().setUserProperties({ 'name': this.user.name, 'organization': this.user.organization, 'cohortName': (this.user['userGroup'] || '') });
    amplitude.getInstance().logEvent('Start an exercise', { 'Course Title': this.exerciseDetails.courseTitle, 'Exercise Title': this.exerciseDetails.title, 'Type of exercise': this.exerciseDetails.type }); */
    // commented for IPJ
    // ga('send', 'event', {
    //   eventCategory: 'Learner Player',
    //   eventAction: 'Start an exercise',
    //   eventLabel: `course: ${this.exerciseDetails.courseTitle}, exercise: ${this.exerciseDetails.title}`
    // });
    // mixpanel.track('Start an exercise', {
    //   'Course Name': this.course.title,
    //   'Exercise Type': this.exerciseDetails.type,
    //   'Exercise Template Name': this.exerciseData.name
    // });
    this.exerciseStarted.emit(true);
  }
  openScoreFaqModal() {
    const modalRef = this.modalService.open(ScoreFaqModalComponent, {
      windowClass: 'modal-cntrl modal-cntrl-lg'
    });
  }
}
